<template>
    <tile class="notes" link="comments">
        <tile-title class="notes__title" slot="tileHeader" icon="pencil">Заметки</tile-title>
        <template v-if="auth">
            <ul v-if="list.length > 0" class="notes__list" slot="tileContent">
                <note-item 
                    v-for="(n, i) in list" :key="i" 
                    :isMyNote="login.toLowerCase() == n.user_login.toLowerCase()"
                    :note="n"
                />
            </ul>
            <p class="empty-message" v-if="list.length === 0" slot="tileContent">Заметки о контрагенте не найдены.</p>
            <note-send slot="tileFooter" />
        </template>
        <demo-message v-if="!auth" slot="tileContent">
            В демо-режиме заметки не отображаются
        </demo-message>
    </tile>
</template>

<script>
import tile from '@/components/ui/tile/tile.vue'
import demoMessage from '@/components/ui/demoMessage/demoMessage.vue'
import tileTitle from '@/components/ui/tileTitle/tileTitle.vue'
import noteItem from '@/components/card/notes/noteItem.vue'
import noteSend from '@/components/card/notes/noteSend.vue'

export default {
    components: {
        tile,
        tileTitle,
        noteItem,
        noteSend,
        demoMessage
    },
    computed: {
        list() { return this.$store.state.card?.notes?.notesList },
        login() { return this.$store.state.user?.apiUser }
    },
    mounted() {
        this.$store.dispatch('card/notes/getNotes')
            .finally(() => {
                $('#link-comments-tile').on('click', () => { window.scrollToElement('comments-tile-link') })
                $('#link-comments-tile').show().text(this.list.length)
            })
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.empty-message
    text-align: center
    font-size: 17px
    color: #777
    margin: 35px
.notes
    padding: 0
    &__title
        padding: 15px 15px 0 15px
    &__list
        max-height: 500px
        min-height: 100px
        width: 100%
        overflow-y: auto
        overflow-x: hidden
        padding: 15px
        display: flex
        flex-direction: column
        align-items: center
        gap: 15px
        margin: 0
        position: relative
        z-index: 1
        @include lic-scroll
</style>